export default __webpack_public_path__ + "static/media/calendar_tick.2a5615ea.svg";